export default {
	actions: {
		authorisedUsers: 'Authorised users',
		backToHome: 'Back to Company information',
		backToHomeKyc: 'Back to KYC form',
		beneficialOwners: 'Beneficial owners',
		companyDetails: 'Company details',
		companyInformation: 'Company information',
		directors: 'Directors',
		summary: 'Summary',
	},
	kycStatusApproved: {
		p1: 'Your company’s information was reviewed and approved by our payments partner.',
		p2: 'You can now use features like Motorway Pay and Motorway Trade.',
		title: 'Company information approved!',
	},
	kycStatusApprovedAuth: {
		p1: "Your company's information was reviewed and approved.",
		p2: 'Your account verification is now complete.',
		title: 'Company information approved!',
	},
	kycStatusButton: 'Back to Home',
	kycStatusComplete: {
		p1: "Thanks for submitting your company's information.",
		p2: "Our team will review and submit the information to our payments partner. We'll contact you if they need any more information or documents.",
		p3: "You don't need to do anything else for now.",
		title: 'Company information submitted',
	},
	kycStatusCompleteAuth: {
		p1: "Thanks for submitting your company's information.",
		p2: "Our team will review your information for authentication and security purposes. We'll contact you if we need any more information or documents.",
		p3: 'You don’t need to do anything else for now.',
		title: 'Company information submitted',
	},
};
